var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsFBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22 14.4a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M2.538 25.615a1.08 1.08 0 0 0 1.077 1.077h15.077a1.08 1.08 0 0 0 1.077-1.077c0-4.07-3.543-8.615-8.615-8.615-5.073 0-8.616 4.545-8.616 8.615m15.519-8.13A8.4 8.4 0 0 1 20.846 17c5.072 0 8.615 4.545 8.615 8.615a1.08 1.08 0 0 1-1.077 1.077H21.73c.118-.334.194-.7.194-1.077 0-2.918-1.443-6.009-3.866-8.13M14.5 9.9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0",
  clipRule: "evenodd"
})));
export default SvgUsFBig;